import logo1 from '../../assets/v-drive-logo.png'

export default function TabDrive() {

  return (
    <div>
      <h3 className="align_center">
        Propellant-Free. Scalable. Energy-Driven.
      </h3>    
             
      <div className="grid-container">
        <div className="grid-item">
          <figure>             
            <img src={logo1} className="logo-big" alt='' />         
          </figure>
        </div>         
        <div className="grid-item">
          <p className='align_left'>
            Modern space propulsion is fundamentally constrained by one key limitation: the need to expel mass. This requirement reduces efficiency, increases system complexity, weight, and cost, and limits long-duration operation.
          </p>          
        </div>
      </div>

          <p className='align_left'>
            V-Drive is designed to explore an alternative.
          </p>
          <b>  ⚙️  Key Advantages</b>
          <p className='align_center'>                 
            <ul className='my-ul'>
              <li><b>No propellant required</b> → reduced system mass, cost, and complexity</li>
              <li><b>Self-sustaining architecture</b> → potential for extended, autonomous operation </li>
              <li><b>Energy-driven</b> → compatible with solar and nuclear power systems</li>
              <li><b>Designed for endurance</b> → suitable for deep-space and long-duration missions</li> 
            </ul>
          </p> 

      <section className="align_left">
        <p>
          A laboratory prototype has been developed and tested under controlled conditions. Experimental testing has produced stable and repeatable results, indicating that the propulsion unit generates controlled, unidirectional force pulses. While further validation is required, the observed behaviour has been consistent across multiple test configurations.
        </p>

        <p>
          We welcome independent evaluation and are happy to share our experimental data, test procedures, and documentation with qualified researchers and organisations interested in reproducing and verifying the results.          
        </p>

        <p>
          We are actively seeking partnerships to support the next stage of development, including advanced instrumentation, independent validation, vacuum testing, and prototype optimisation. We welcome collaboration with research institutions, aerospace companies, engineering teams, and strategic investors interested in advancing next-generation propulsion technologies. We are also exploring the formation of a joint venture or consortium to develop a CubeSat mission for in-space validation of the V-Drive concept.          
        </p>
      </section>
  </div>
  )
}
